import AGENT_1_SVG from './svgs/agent1.svg';
import AGENT_1_INVERSION_SVG from './svgs/agent1--inversion.svg';
import AGENT_2_SVG from './svgs/agent2.svg';
import AGENT_2_INVERSION_SVG from './svgs/agent2--inversion.svg';
import AGENT_3_1_SVG from './svgs/agent3--1.svg';
import AGENT_3_2_SVG from './svgs/agent3--2.svg';
import AGENT_3_3_SVG from './svgs/agent3--3.svg';
import AGENT_3_4_SVG from './svgs/agent3--4.svg';
import AGENT_4_SVG from './svgs/agent4.svg';

export default {
  AGENT_1_SVG,
  AGENT_1_INVERSION_SVG,
  AGENT_2_SVG,
  AGENT_2_INVERSION_SVG,
  AGENT_3_1_SVG,
  AGENT_3_2_SVG,
  AGENT_3_3_SVG,
  AGENT_3_4_SVG,
  AGENT_4_SVG,
};
